/*
 * This is not a module file and is not intended to be used in faff.js, instead it is meant to be called by modules.
 */
export function autocomplete ({
  inputEl,
  // GOOGLE OPTIONS - https://developers.google.com/maps/documentation/javascript/places-autocomplete#add_autocomplete
  types = ['(regions)'],
  componentRestrictions = { country: 'us' },
  fields = ['place_id'], // https://developers.google.com/maps/documentation/javascript/reference/places-service#PlaceResult
  // END GOOGLE OPTIONS
  onChange = null,
  onAutocompleteSelect = null
}) {
  getAutocomplete(inputEl, { types, componentRestrictions, fields })
    .then((autocomplete) => {
      if (onChange) {
        inputEl.addEventListener('change', onChange)
      }
      if (onAutocompleteSelect) {
        autocomplete.addListener('place_changed', () => {
          onAutocompleteSelect(autocomplete.getPlace())
        })
      }
    })
}

function isGoogleReady () {
  return Boolean(window && window.google && window.google.maps && window.google.maps.event)
}

function waitForGoogle () {
  return new Promise((resolve) => {
    const waitForGoogleInterval = setInterval(() => {
      if (isGoogleReady()) {
        clearInterval(waitForGoogleInterval)
        return resolve()
      }
    }, 300)
  })
}

function initAutocomplete (inputEl, autocompleteOptions) {
  return new window.google.maps.places.Autocomplete(inputEl, autocompleteOptions)
}

function getAutocomplete (inputEl, options) {
  if (isGoogleReady()) {
    return Promise.resolve(initAutocomplete(inputEl, options))
  }

  return waitForGoogle(inputEl, options)
    .then(() => initAutocomplete(inputEl, options))
}
